import * as React from "react";
import type { SVGProps } from "react";

interface StartShootoutProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const StartShootout = ({ cancelled = false, ...props }: StartShootoutProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M1.07 4.47h20.76v12H1.07z" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M20.9 3.25c1.3 0 2.35 1.05 2.35 2.35v10.94c0 .69-.56 1.25-1.25 1.25h-.37c-.69 0-1.25-.56-1.25-1.25V6.12H3.62v10.42c0 .65-.5 1.18-1.12 1.24H2c-.69 0-1.25-.55-1.25-1.24V5.6c0-1.3 1.05-2.35 2.35-2.35z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M20.9 4c.88 0 1.6.72 1.6 1.6v10.94a.5.5 0 0 1-.5.5h-.37a.5.5 0 0 1-.5-.5V5.6c0-.13-.1-.23-.23-.23H3.1c-.13 0-.23.1-.23.23v10.94a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V5.6c0-.88.72-1.6 1.6-1.6z"
      />
      <path
        fill="#007BBD"
        fillRule="nonzero"
        d="M6.34 14.88q-.6 0-.6-.6V9.8l-.6.38c-.38.23-.67.19-.88-.13-.1-.15-.13-.3-.1-.44.05-.14.16-.26.34-.35l1.14-.66a1.4 1.4 0 0 1 .82-.22c.32 0 .47.2.47.62v5.27c0 .41-.2.61-.59.61m4.16 0q-.6 0-.6-.6V9.8l-.6.38c-.38.23-.67.19-.88-.13-.1-.15-.13-.3-.1-.44.05-.14.16-.26.34-.35L9.8 8.6a1.4 1.4 0 0 1 .82-.22c.32 0 .47.2.47.62v5.27c0 .41-.2.61-.59.61m3.1 0c-.45 0-.67-.2-.67-.6V9c0-.24.07-.4.2-.49.14-.08.33-.13.58-.13q.525 0 .78.42l1.64 2.64 1.62-2.63a.8.8 0 0 1 .37-.34q.21-.09.54-.09c.44 0 .66.2.66.62v5.26c0 .41-.22.61-.66.61q-.66 0-.66-.6v-3.8l-1.24 2.1c-.16.28-.37.42-.64.42-.26 0-.48-.14-.64-.42l-1.24-2.1v3.8c0 .4-.21.6-.65.6Z"
      />
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M6.82 18.71c-.8.66-.93 1.84-.28 2.65l.59.72c.55.69 1.51.9 2.3.5l3.97-1.97.14.15a5.37 5.37 0 0 0 7.1.64l.17-.14a5.35 5.35 0 0 0 1.82-5.43l-.01-.07.05-.04c.57-.64.64-1.6.14-2.33l-.08-.11a1.88 1.88 0 0 0-2.15-.58l-.04.02a5.36 5.36 0 0 0-6.34.02l-.18.14a1.6 1.6 0 0 0-.5 1.75l.02.07-1.03.84a1.66 1.66 0 0 0-1.81.04l-.12.08z"
        />
        <path
          fill="#000"
          d="M7.2 19.18a1.28 1.28 0 0 0-.2 1.8l.6.73c.37.46 1.02.6 1.56.34l4.2-2.1a.28.28 0 0 1 .35.09l.02.02a4.76 4.76 0 0 0 8.23-4.44l-.03-.07.02-.01.13-.09c.54-.44.62-1.25.18-1.8a1.28 1.28 0 0 0-1.8-.2h.03l-.06-.06a4.77 4.77 0 0 0-5.85-.18l-.18.13a1 1 0 0 0-.15 1.41l.04.05c.02.02.02.06 0 .08l-1.76 1.41a.06.06 0 0 1-.08 0 1.06 1.06 0 0 0-1.49-.16zm.63.78 3.76-3.05a.06.06 0 0 1 .08 0c.37.46 1.04.53 1.5.16l1.74-1.41c.46-.37.53-1.04.16-1.5l-.04-.04.16-.12a3.77 3.77 0 0 1 4.84.38l.14.14a.5.5 0 0 0 .84-.17.26.26 0 0 1 .08-.11c.12-.1.3-.08.4.04s.07.3-.04.4a.26.26 0 0 1-.18.05.5.5 0 0 0-.46.72 3.76 3.76 0 0 1-1 4.57 3.77 3.77 0 0 1-5.3-.59l-.02-.01a1.28 1.28 0 0 0-1.58-.36l-4.2 2.1a.28.28 0 0 1-.34-.08l-.59-.73a.28.28 0 0 1 .05-.4Z"
        />
        <path
          fill="#000"
          d="M15.95 15.23c-.99.82-1.14 2.3-.33 3.3a2.3 2.3 0 0 0 3.25.35c1-.81 1.15-2.29.34-3.3a2.3 2.3 0 0 0-3.26-.35m.64.78a1.3 1.3 0 0 1 1.84.2c.47.58.38 1.43-.19 1.9a1.3 1.3 0 0 1-1.84-.2 1.36 1.36 0 0 1 .19-1.9"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default StartShootout;
